export default function isRKSVCode(code) {
  return code && code.length > 100 && code.startsWith('_R');
}